import { addFramesStyles, addMarginStyles, addPaddingStyles, addTransition } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledNeutralButton = styled.button<{
	disabled?: boolean;
	display?: string;
	vertical?: string;
	isHidden?: boolean;
}>`
	position: relative;

	border: none;
	background-color: transparent;

	${addTransition()}

	${(p) => css`
		${addPaddingStyles(p)}
		${addMarginStyles(p)}
		${addFramesStyles(p)}

		${p.display ? `display: ${p.display};` : ''}
		${p.vertical ? `align-items: ${p.vertical};` : ''}

		${p.disabled
			? `
			opacity: 0.3;
			cursor: default;
			`
			: css`
					cursor: pointer;
					@media (hover: hover) {
						&:hover {
							opacity: 0.8;
						}
					}
			  `}

		${p.isHidden
			? `
			opacity: 0.0;
			cursor: default;

			@media (hover: hover) {
				&:hover { opacity: 0; }
			}
			`
			: ''}
	`}
`;
